import { Injectable } from '@angular/core';
import { LocaleHelperService } from '@finder/shared/services/locale-service/locale-helper.service';
import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';

@Injectable()
export class WebLinkValidationService {

    constructor(
        private localeHelper: LocaleHelperService,
        private windowRef: WindowRef
    ) {}

    validateWebLink(webLink) {
        if (!webLink) {
            // if there is no webLink in service just return.
            return;
        }
        webLink = this.normalizeWebLink(webLink);

        let currentPath = this.windowRef.nativeWindow.location.pathname;
        currentPath = this.localeHelper.stripLocale(currentPath);
        currentPath = this.removeLastSlash(currentPath);

        if (!currentPath.includes(webLink)) {
            // redirect to webLink
            this.windowRef.nativeWindow.location.href =
                this.windowRef.nativeWindow.location.href.replace(currentPath, webLink);
        }
    }

    private normalizeWebLink(webLink) {
        webLink = this.removeLastSlash(webLink);
        // remove domain
        webLink = webLink.replace(/^(http|https)?:\/\/[^\/]+/i, '');
        // remove locale
        webLink = this.localeHelper.stripLocale(webLink);
        return webLink;
    }

    private removeLastSlash(webLink) {
        if (!webLink) {
            return webLink;
        }
        // remove last '/'
        webLink =
            webLink.lastIndexOf('/') === webLink.length - 1 ?
            webLink.substr(0, webLink.lastIndexOf('/')) :
            webLink;

        return webLink;
    }
}
